export default __webpack_public_path__ + "static/media/app-bar-login.21d0cab6.svg";